// utils/groupSchedule.js
//
// Pure fetch — no transformation.
// Returns raw scheduled group messages ready for UI / IDB.

import axios from "axios";

/* =========================================================
   fetchGroupScheduledMessages
========================================================= */
export const fetchGroupScheduledMessages = async (myChatId) => {
  const start = Date.now();

  try {
    const res = await axios.get(
      `/api/schedule/group`,
      {
        params: myChatId ? { chatId: myChatId } : {},
        withCredentials: true,
      }
    );

    const messages = res.data?.data;


    if (!Array.isArray(messages) || messages.length === 0) {
   
      return [];
    }

    return messages; // ✅ raw
  } catch (err) {
  
    return [];
  }
};